import { globals } from '../../globals'

// ------------------------------------
// Constants
// ------------------------------------
export const UPDATE_FAVORITES_COMB_DATA = 'UPDATE_FAVORITES_COMB_DATA'
export const ALL_FAVORITE_FETCHED = 'ALL_FAVORITE_FETCHED'
export const ALL_GET_FAVORITE_START = 'ALL_GET_FAVORITE_START'
export const ALL_GET_FAVORITE_FAILED = 'GET_FROM_FAVORITE_FAILED'

// ------------------------------------
// Actions
// ------------------------------------
export const actions = {
  getAllFavoritesList,
  updateFavoritesCombData
}

export function updateFavoritesCombData (location, valueType, valueID, fieldValue) {
  return {
    type: UPDATE_FAVORITES_COMB_DATA,
    location,
    valueType,
    payload: {
      value: valueID,
      fieldValue: fieldValue,
    }
  }
}

export function getAllFavoritesList () {
  return (dispatch) => {
    dispatch({ type: ALL_GET_FAVORITE_START })
    const headers = {
      'Content-Type': 'application/json',
    }
    const options = {
      method: 'GET',
      credentials: 'include',
      headers,
    }
    fetch(`${globals.apiUrl}/api/personallist`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 404) {
        dispatch({
          type: ALL_FAVORITE_FETCHED,
          payload: {
            json: [],
          },
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: ALL_FAVORITE_FETCHED,
          payload: {
            json,
          },
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: ALL_GET_FAVORITE_FAILED })
    })
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_FAVORITES_COMB_DATA] : (state, action) => {
    switch (action.valueType) {
      case 'datetime': {
        const { value, fieldValue } = action.payload
        return {
          ...state,
          formDataValue: {
            ...state.formDataValue,
            favoritesDashboard: {
              ...state.formDataValue.favoritesDashboard,
              dateTime: {
                ...state.formDataValue.favoritesDashboard.dateTime,
                [value]: fieldValue,
              }
            }
          }
        }
      }
      case 'textinput' : {
        // set text value
        const { page, field } = action.location
        const { value, fieldValue } = action.payload
        return {
          ...state,
          formDataValue: {
            ...state.formDataValue,
            [page]: {
              ...state.formDataValue[page],
              [field]: {
                ...state.formDataValue[page][field],
                textValues: {
                  ...state.formDataValue[page][field].textValues,
                  [value]: fieldValue,
                }
              }
            }
          }
        }
      }
    }
  },
  [ALL_GET_FAVORITE_START] : (state) => {
    return {
      ...state,
      isFetchingData: true,
    }
  },
  [ALL_FAVORITE_FETCHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        allFavorites: json
      },
    }
  },
  [ALL_GET_FAVORITE_FAILED] : (state) => {
    return {
      ...state,
      isFetchingData: false
    }
  },
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetchingData: true,
  errorCode: '',
  renderData: {},
  formDataValue: {
    favoritesDashboard: {
      dateTime: {
        updatedFrom: ' ',
        updatedTo: ' '
      }
    }
  },
}

export default function favoritesCombReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/favoritesComb.js